import React, { useEffect, useState, useCallback, useRef } from 'react';
import { GoogleMap, LoadScript, Marker, Autocomplete } from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '500px'
};

const center = {
    lat: 37.7749, // Default latitude
    lng: -122.4194 // Default longitude
};

const GoogleMapComponent = ({ onLocationSelect, defaultPosition }) => {
    const [markerPosition, setMarkerPosition] = useState(defaultPosition || center);
    const [map, setMap] = useState(null);
    const autocompleteRef = useRef(null);

    // ✅ Update marker when defaultPosition changes (for Edit mode)
    useEffect(() => {
        if (defaultPosition) {
            setMarkerPosition(defaultPosition);
            if (map) {
                map.panTo(defaultPosition);
            }
        }
    }, [defaultPosition, map]);


    const handleLoad = mapInstance => setMap(mapInstance);

    const onPlaceChanged = () => {
        if (autocompleteRef.current !== null) {
            const place = autocompleteRef.current.getPlace();        
            //if (place.geometry) {
            if (place?.geometry?.location) {
                const newPosition = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                };
                setMarkerPosition(newPosition);
                map.panTo(newPosition);
                onLocationSelect(newPosition);
                //selectedLoc(newPosition);
            } else {
                console.error("Place or geometry not available", place);
            }
        }
    };


    const handleMarkerDragEnd = (e) => {
        const newPos = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
        };
        setMarkerPosition(newPos);
        onLocationSelect(newPos);
    };

    /*const handleMarkerDragEnd = (e) => {
            setMarkerPosition({
                lat: e.latLng.lat(),
                lng: e.latLng.lng()
            });
    
            onLocationSelect({
                lat: e.latLng.lat(),
                lng: e.latLng.lng()
            });
    
            // selectedLoc({
            //     lat: e.latLng.lat(),
            //     lng: e.latLng.lng()
            // });        
        }; */





    const libraries = ["places"];

    return (
        <LoadScript
            googleMapsApiKey="AIzaSyBEoLv9QWRvhRdVoxtaPu9Mg5PR6OtoNUA"
            libraries={libraries}
        >
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={markerPosition}
                zoom={14}
                onLoad={handleLoad}
            >
                <Autocomplete
                    onLoad={ref => autocompleteRef.current = ref}
                    onPlaceChanged={onPlaceChanged}
                >
                    <input
                        type="text"
                        placeholder="Search Location"
                        style={{
                            margin: `10px`,
                            zIndex: `0`,
                            position: `absolute`,
                            cursor: `pointer`,
                            left: `0px`,
                            top: `50px`,
                            boxSizing: `border-box`,
                            marginBottom: `10px`,
                            border: `1px solid transparent`,
                            width: `240px`,
                            height: `32px`,
                            padding: `0 12px`,
                            borderRadius: `3px`,
                            boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                            fontSize: `14px`,
                            outline: `none`,
                            textOverflow: `ellipses`,
                        }}
                    />
                </Autocomplete>
                <Marker
                    position={markerPosition}
                    draggable={true}
                    onDragEnd={handleMarkerDragEnd}
                />
            </GoogleMap>
        </LoadScript>
    );
};

export default GoogleMapComponent;